/* eslint-disable */
import { Box, TextField, MenuItem, FormControl, styled, Card, useTheme, Typography, Grid, Select, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const BoxWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  "& .MainHeading": {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "1",
    color: theme.palette.text.primary,
    marginBottom: "16px",
  },
  "& .SearchFilter": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
    },
    "& .MuiFormControl-root": {
      "& label": {
        marginBottom: "0",
        top: "50%",
        transform: "translate(14px, -50%)",
        "&.MuiInputLabel-shrink": {
          top: "0",
          transform: "translate(14px, -9px) scale(0.75)",
        },
      },
      "& .MuiFormHelperText-root": {
        position: "absolute",
        top: "40px",
        left: "0",
        color: "#FA896B",
      },
    },
    "& .SearchIcon": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      minWidth: "auto",
      padding: "11px 10px 9px",
      "& .MuiCircularProgress-root": {
        color: "#fff",
      },
    },
  },
}));

const KeywordHeader = ({ handleChange }) => {
  const theme = useTheme();

  return (
    <BoxWrapper>
      <Card sx={{ padding: "16px 24px 24px 24px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
        <Typography className="MainHeading" component="h2">
          Ranking Table
        </Typography>
        <Grid container spacing={2} sx={{ alignItems: "center" }}>
          <Grid item xs={12} md={8}>
            <Box className="SearchFilter">
              <FormControl sx={{ minWidth: { xs: "100%", sm: "500px" } }}>
                <TextField
                  variant="outlined"
                  placeholder="Search keyword"
                  name="search"
                  onChange={handleChange}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </BoxWrapper>
  );
};

export default KeywordHeader;
